import Banner from './componenets/Banner';
import Row from './componenets/Row';
import requests from './requests';
import './App.css'
import Nav from './componenets/Nav';
import React from 'react';


function App() {
  return (
    <div className="App">
      {/*NAVBAR*/}
      <Nav></Nav>
      {/*BANNER*/}
      <Banner ></Banner>
      {/*ROWS*/}
      <Row title="NETFLIX ORIGINALS" fetchUrl={requests.fetchNetflixOriginals} isLargeNow></Row>
      <Row title="Trending" fetchUrl={requests.fetchTrending}></Row>
      <Row title="TopRated" fetchUrl={requests.fetchTopRated}></Row>
      <Row title="Action Movies" fetchUrl={requests.fetchActionMovies}></Row>
      <Row title="Comedy Movies" fetchUrl={requests.fetchComedyMovies}></Row>
      <Row title="Horror Movies" fetchUrl={requests.fetchHorrorMovies}></Row>
      <Row title="Romance Movies" fetchUrl={requests.fetchRomanceMovies}></Row>
      <Row title="Documentaries" fetchUrl={requests.fetchDocumentaries}></Row>
    </div>
  );
}

export default App;
